import { FaTableList } from "react-icons/fa6";

import withDocumentTitle from "../withDocumentTitle";

import ReturnPermissionSetting from "./ReturnPermissionSetting";

import AccordionCard from "../AccordionCard";

function Settings() {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-10">
      <div className="tw-w-full lg:tw-w-4/5">
        <AccordionCard
          eventKey="return-permission-setting"
          title="Return Permissions"
          icon={({ className }) => <FaTableList className={className} />}
        >
          <ReturnPermissionSetting />
        </AccordionCard>
      </div>
    </div>
  );
}

export default withDocumentTitle(Settings, {
  documentTitle: "Settings",
  showTitle: false,
});
